const APIv4MetaproductsAdapters = {
  mapMetaproducts: (product, metaproductData, possibleColors) => {
    const hasMetaproducts = metaproductData.options && metaproductData.options.EN.options;
    const metaChildrensWithTwoLevels = APIv4MetaproductsAdapters.getTwoLevelsChildrens(!!hasMetaproducts, metaproductData);
    const hasTwoMetaLevels = metaChildrensWithTwoLevels.length > 0;
    if (!hasMetaproducts) {
      return [];
    }
    let metaType = 'option';
    const hasColorReferences = Object.keys(possibleColors).length !== 0;
    if (hasColorReferences && Object.keys(possibleColors).includes(metaproductData.options.EN.options[0].value)) {
      metaType = 'color';
    }
    if (!hasTwoMetaLevels && hasColorReferences) {
      const metaproducts = [];
      if (metaType === 'color') {
        const colorsMetaproduct = APIv4MetaproductsAdapters.mapColorMetaproduct(product, metaproductData);
        if (colorsMetaproduct.options.length > 0) {
          metaproducts.push(colorsMetaproduct);
        }
      } else {
        const optionsMetaproduct = APIv4MetaproductsAdapters.mapOptionsMetaproduct(product, metaproductData);
        if (optionsMetaproduct.options.length > 0) {
          metaproducts.push(optionsMetaproduct);
        }
      }
      return metaproducts;
    }
    return APIv4MetaproductsAdapters.mapTwoLevelsMetaproducts(product, metaproductData);
  },
  mapTwoLevelsMetaproducts: (product, metaproductData) => {
    const metaproducts = [];
    const productID = product.id ?? product.productID;
    const colorHexcode = APIv4MetaproductsAdapters.setHexCodeColor(product);
    const specific = APIv4MetaproductsAdapters.setSpecific(product);
    const parentColor = APIv4MetaproductsAdapters.getParentColor(specific);
    // Map & push two levels OPTIONS Metaproduct
    const optionsMetaproduct = APIv4MetaproductsAdapters.mapTwoLevelsOptionsMetaproduct(metaproductData.options, productID, parentColor);
    if (optionsMetaproduct.options.length > 0) {
      metaproducts.push(optionsMetaproduct);
    }
    // Map & push two levels COLOR Metaproduct
    const optionsIndex = optionsMetaproduct.options.findIndex(option => option.id === productID) || 0;
    const colorMetaproduct = APIv4MetaproductsAdapters.mapTwoLevelsColorsMetaproduct(metaproductData.options, parentColor, colorHexcode, optionsIndex);
    if (colorMetaproduct.options.length > 0) {
      metaproducts.push(colorMetaproduct);
    }
    return metaproducts;
  },
  mapTwoLevelsColorsMetaproduct: (metaproductData, parentProductColor, parentProductColorHexcode, productOptionPosition) => {
    const metaproduct = {
      type: 'color',
      parentProduct: {
        color: parentProductColor,
        colorHexcode: parentProductColorHexcode
      },
      options: []
    };
    const addedColours = [];
    metaproductData.EN.options.forEach(data => {
      if (data.options) {
        const optionsOnSpecificColour = data.options[productOptionPosition] ?? data.options[0];
        const colour = APIv4MetaproductsAdapters.toCapitalize(data.value);
        const hexcode = APIv4MetaproductsAdapters.getProductColor(optionsOnSpecificColour);
        if (!addedColours.includes(colour)) {
          metaproduct.options.push({
            label: APIv4MetaproductsAdapters.toCapitalize(optionsOnSpecificColour.value),
            title: optionsOnSpecificColour.product_title,
            color: colour,
            hexcode: hexcode,
            id: optionsOnSpecificColour.productID,
            hasStock: optionsOnSpecificColour.has_stock,
            stockPolicy: optionsOnSpecificColour.stock_policy,
            price: optionsOnSpecificColour.price
          });
          addedColours.push(colour);
        }
      }
    });
    return metaproduct;
  },
  mapColorMetaproduct: (product, metaproductData) => {
    const colorHexcode = APIv4MetaproductsAdapters.setHexCodeColor(product);
    const specific = APIv4MetaproductsAdapters.setSpecific(product);
    const parentColor = APIv4MetaproductsAdapters.getParentColor(specific);
    const metaproduct = {
      type: 'color',
      parentProduct: {
        color: parentColor,
        colorHexcode
      },
      options: []
    };
    metaproductData.options.EN.options.forEach(data => {
      const hexcode = APIv4MetaproductsAdapters.getProductColor(data);
      metaproduct.options.push({
        label: APIv4MetaproductsAdapters.toCapitalize(data.value),
        title: data.product_title,
        color: APIv4MetaproductsAdapters.toCapitalize(data.value),
        hexcode: hexcode,
        id: data.productID,
        hasStock: data.has_stock,
        stockPolicy: data.stock_policy,
        price: data.price
      });
    });
    return metaproduct;
  },
  mapTwoLevelsOptionsMetaproduct: (metaproductData, productID, parentColour) => {
    const metaproduct = {
      parentProduct: {
        id: productID
      },
      type: 'options',
      options: []
    };
    metaproductData.EN.options.forEach(options => {
      if (options.options) {
        options.options.forEach(data => {
          const hexcode = APIv4MetaproductsAdapters.getProductColor(data);
          if (APIv4MetaproductsAdapters.toCapitalize(options.value) === parentColour) {
            metaproduct.options.push({
              label: APIv4MetaproductsAdapters.toCapitalize(data.value),
              title: data.product_title,
              color: APIv4MetaproductsAdapters.toCapitalize(options.value),
              hexcode: hexcode,
              id: data.productID,
              hasStock: data.has_stock,
              stockPolicy: data.stock_policy,
              price: data.price
            });
          }
        });
      }
    });
    return metaproduct;
  },
  mapOptionsMetaproduct: (product, metaproductData) => {
    const productID = product.id ?? product.productID;
    const metaproduct = {
      parentProduct: {
        id: productID
      },
      type: 'options',
      options: []
    };
    metaproductData.options.EN.options.forEach(data => {
      metaproduct.options.push({
        label: APIv4MetaproductsAdapters.toCapitalize(data.value),
        title: data.product_title,
        id: data.productID,
        hasStock: data.has_stock,
        stockPolicy: data.stock_policy,
        price: data.price
      });
    });
    return metaproduct;
  },
  toCapitalize(str) {
    const str2 = str.toLowerCase();
    return str2.charAt(0).toUpperCase() + str2.slice(1);
  },
  setHexCodeColor(product) {
    let color;
    if (product.custom_fields) {
      color = product.custom_fields.filter(customField => customField.type === 'CF_HEXCODE');
    }
    return color?.length > 0 ? color[0].value : '';
  },
  setSpecific(product) {
    if (product.specificV4) {
      return product.specificV4;
    } else {
      return product.specific;
    }
  },
  // when getting the color from metaproduct parent => specific.extension.videogame.platform
  // when accessing from child => specific.options?.EN.options[0].value
  getParentColor(specific) {
    return APIv4MetaproductsAdapters.toCapitalize(specific.extension?.videogame?.platform ?? specific.options?.EN.options[0].value);
  },
  getProductColor(options) {
    let hexcode = '';
    if (!options || !options.custom_fields) {
      return hexcode;
    }
    options.custom_fields.filter(field => field.type == 'CF_HEXCODE').forEach(field => {
      hexcode = field.value;
    });
    return hexcode;
  },
  getTwoLevelsChildrens(hasMetaproducts, metaproductData) {
    if (!hasMetaproducts && !metaproductData?.options?.EN?.options) {
      return [];
    }
    return metaproductData.options.EN.options.filter(child => child.options);
  }
};
export default APIv4MetaproductsAdapters;
